var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import propsToUtilClasses from './utils/propsToUtilClasses';
import restProps from './utils/restProps';

var Base = function (_Component) {
  _inherits(Base, _Component);

  function Base() {
    _classCallCheck(this, Base);

    return _possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).apply(this, arguments));
  }

  _createClass(Base, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.tagName,
          children = _props.children,
          className = _props.className;


      var classes = classnames(className, propsToUtilClasses(this.props));

      var rest = restProps(Base.propTypes, this.props);

      return React.createElement(
        Component,
        _extends({ className: classes }, rest),
        children
      );
    }
  }]);

  return Base;
}(Component);

Base.defaultProps = {
  tagName: 'div'
};
Base.propTypes = {
  /** HTML element string or React component to render */
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.element]),
  /** Applies extra classes to component */
  className: PropTypes.string,

  /** HTML element or React component to render */
  children: PropTypes.node,

  /** Applies vertical align using align items */
  uAi: PropTypes.string,
  /** Applies vertical align using align utility */
  uAlign: PropTypes.string,
  /** Applies background color value using bgcolor utility */
  uBgcolor: PropTypes.string,
  /** Applies clearfix using clearfix utility */
  uCf: PropTypes.bool,
  /** Applies color value using color utility */
  uColor: PropTypes.string,
  /** Applies display type using display utility */
  uDisplay: PropTypes.string,
  /** Applies flex direction using flex direction utility */
  uFd: PropTypes.string,
  /** Applies float direction using float utility */
  uFloat: PropTypes.string,
  /** Applies horizontal alignment using justify content utility */
  uJc: PropTypes.string,
  /** Applies margin using margin utility */
  uM: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies margin top using margin utility */
  uMt: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies margin right using margin utility */
  uMr: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies margin bottom using margin utility */
  uMb: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies margin left using margin utility */
  uMl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies vertical margin using margin utility */
  uMv: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies horizontal margin using margin utility */
  uMh: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies opacity size using opacity utility */
  uOpacity: PropTypes.string,
  /** Applies padding using margin utility */
  uP: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies padding top using margin utility */
  uPt: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies padding right using margin utility */
  uPr: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies padding bottom using margin utility */
  uPb: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies padding left using margin utility */
  uPl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies vertical padding using margin utility */
  uPv: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies horizontal padding using margin utility */
  uPh: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Applies position type using position utility */
  uPosition: PropTypes.string,
  /** Applies after offset using pull utility */
  uPull: PropTypes.string,
  /** Applies offset using push utility */
  uPush: PropTypes.string,
  /** Applies width size using size utility */
  uSize: PropTypes.string,
  /** Applies text alignment using text utility */
  uText: PropTypes.string,
  /** Applies text transform using transform utility */
  uTransform: PropTypes.string,
  /** Applies font weight size using weight utility */
  uWeight: PropTypes.string
};


export default Base;